export default function () {
  return {
    create: {
      datetime: null,
      error: null,
      item: {},
      loading: false,
    },
    read: {
      datetime: null,
      error: null,
      item: {},
      loading: false,
    },
    update: {
      datetime: null,
      error: null,
      item: {},
      loading: false,
    },
    delete: {
      datetime: null,
      error: null,
      item: {},
      loading: false,
    },
    list: {
      datetime: null,
      error: null,
      filters: {},
      items: {},
      loading: false,
    },
  };
}
